import AttributeTable from './attribute_table'

export default AttributeTable
